export const quickRegister: boolean = true; // Change to false turn the original many-step registration wizard back on
